/**
 * OOI-specific experiments should be listed here.
 * scope: viewer-apps-14bcded7-0066-7c35-14d7-466cb3f09103
 */
export const OOI_EXPERIMENTS = {
  /**
   * https://bo.wix.com/petri/experiments/2438127
   * - Blog Live Site Editor Deprecation
   */
  LIVE_SITE_EDITOR_DEPRECATION: 'specs.wixBlog.LiveSiteEditorDeprication',
  /**
   * - Users: TBD
   * - Employees: https://bo.wix.com/guineapig/experiments/4267517
   **/
  OPTIMIZE_READ_TIME_BI_EVENT: 'specs.wixBlog.OptimizeReadTimeBiEvent',
  /**
   * Enable Header Image in the post composer
   * https://bo.wix.com/guineapig/experiments/4253060
   */
  HEADER_IMAGE: 'specs.wixBlog.HeaderImage',
  /**
   * Does not allow to install blog members area apps in the editor.
   * https://bo.wix.com/guineapig/experiments/4288493
   */
  DONT_REGISTER_MEMBER_PAGES: 'specs.wixBlog.DontRegisterMemberPages',
  USE_LAYOUT_FIXER: 'specs.wixBlog.UseLayoutFixer',
  MIGRATE_CUSTOM_FEED_ON_EDITOR_READY: 'specs.wixBlog.MigrateCustomFeedOnEditorReady',
  HASHTAG_PAGE_USE_FEED_PAGE: 'specs.wixBlog.HashtagPageUseFeedPage',
};
